import ApperIcon from '@/components/ApperIcon';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { LANGUAGES, useT } from '@/shared/i18n';
import { cn } from '@/lib/utils';

/** Language switcher. Shows the current language in its own script. */
export default function LanguagePicker({ className, full = false }) {
  const { t, lang, setLanguage } = useT();
  const current = LANGUAGES.find((l) => l.code === lang) ?? LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={cn('gap-1.5', className)}
          aria-label={`${t('Language')}: ${current.label}`}
        >
          <ApperIcon name="Languages" size={16} />
          <span className={cn(!full && 'hidden sm:inline')}>{current.label}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        <DropdownMenuLabel className="text-xs text-muted-foreground">{t('Language')}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            lang={l.code}
            dir={l.rtl ? 'rtl' : 'ltr'}
            onClick={() => setLanguage(l.code)}
            className="justify-between"
          >
            {l.label}
            {l.code === lang && <ApperIcon name="Check" size={14} className="text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
